import { ServiceResponse } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { TransportRegistration } from '../model/transport-registration';
import { TransportRegistrationIdentity } from '../model/out/transport-registration-identity';
import { TrransportRegistrationServiceResponse } from '../model/trransport-registration-service-response';
import { Route } from '../model/route';
import { TransportRouteSelection } from '../model/out/transport-route-selection';

@Injectable({
  providedIn: 'root'
})
export class TransportRegistrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  getNewRegistration(identity: TransportRegistrationIdentity): Observable<TransportRegistration> {
    return this.appServerAPI.execute(`/client/control/transport/registration/new`, identity);
  }

  save(transportRegistration: TransportRegistration): Observable<TrransportRegistrationServiceResponse> {
    return this.appServerAPI.execute(`/client/control/transport/registration/save`, transportRegistration);
  }

  findCarriersStartingByName(name: string): Observable<string[]> {
    return this.appServerAPI.execute(`/client/control/transport/registration/carriers-by-name`, name);
  }

  findString1StartingWith(name: string): Observable<string[]> {
    return this.appServerAPI.execute(`/client/control/transport/registration/string1`, name);
  }

  findNumberPlatesStartingWith(name: string): Observable<string[]> {
    return this.appServerAPI.execute(`/client/control/transport/registration/numberplates`, name);
  }

  getPositionsforTransportOptions(selection: TransportRouteSelection): Observable<Route> {
    return this.appServerAPI.execute(`/client/control/transport/registration/option-positions`, selection);
  }

  validateMasterdata(transportRegistration: TransportRegistration): Observable<ServiceResponse> {
    return this.appServerAPI.execute(`/client/control/transport/registration/validate-masterdata`, transportRegistration);
  }
}
